export default function replaceUrlTags(url, row) {
  return url.replace(/\{([\w-]+)\}/gi, (match, param) => row.getData()[param] || '');
}
